import { getHospitalDetailsAPI } from "../adapter/cms-adapter";

export const getHospitalDetails = (data) => {

    let reqData = {
        hospital_id: 1
    }

    let promise = new Promise(function (resolve, reject) {

        getHospitalDetailsAPI(reqData).then((res) => {

            if (res && res.data) resolve(res.data);

            else reject("some error message getHospitalDetails");
        })
    })

    return promise;
}